var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "FormShareFast" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "form-group" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "link-group" }, [
          _c("div", { staticClass: "link-input" }, [
            _c("i", { staticClass: "icon link-icon md-icon" }, [
              _vm._v("link"),
            ]),
            _vm._v(" "),
            _c("input", {
              attrs: { type: "text", readonly: "" },
              domProps: { value: _vm.formattedUrl },
            }),
            _vm._v(" "),
            _c("i", { staticClass: "icon edit-icon md-icon" }, [
              _vm._v("edit"),
            ]),
            _vm._v(" "),
            _c("i", { staticClass: "icon refresh-icon md-icon" }, [
              _vm._v("refresh"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "buttons" }, [
            _c(
              "button",
              { staticClass: "copy-link", on: { click: _vm.coppyUrl } },
              [_vm._v("BAĞLANTIYI KOPYALA")]
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "open-new-tab", on: { click: _vm.openInNewTab } },
              [_vm._v("YENİ SEKMENDE AÇ")]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "icon-container" }, [
        _c("i", { staticClass: "md-icon" }, [_vm._v("link")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-container" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v("FORMUNUZUN BAĞLANTI ADRESİ"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "description" }, [
          _vm._v(
            "Formunuz güvenli bir şekilde yayınlandı ve bu adreste kullanıma hazır."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-header" }, [
      _c("h2", [_vm._v("BAĞLANTI İLE PAYLAŞ")]),
      _vm._v(" "),
      _c("button", { staticClass: "public-form" }, [
        _c("i", { staticClass: "icon md-icon" }, [_vm._v("lock_open")]),
        _vm._v(" Herkese Açık Form\n                    "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }